import { Outlet } from 'react-router-dom';

const ContestLayout = () => {
  return (
    <div className="from-base-500 via-base-200 to-base-500 dark:from-content-700 dark:via-content-900 dark:to-content-800 relative min-h-screen overflow-hidden bg-gradient-to-br">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-20 top-10 h-64 w-64 rounded-full bg-primary-200/30 blur-3xl dark:bg-primary-700/20" />
        <div className="absolute -right-16 top-28 h-72 w-72 rounded-full bg-accent-200/30 blur-3xl dark:bg-accent-700/20" />
        <div className="absolute bottom-0 left-1/4 h-56 w-56 rounded-full bg-primary-100/40 blur-3xl dark:bg-primary-900/20" />
      </div>

      <div className="2xl:max-w-8xl relative z-10 mx-auto w-full max-w-6xl px-3 pb-8 pt-3 sm:px-4 sm:pb-10 sm:pt-5 lg:px-6 xl:pt-10">
        <Outlet />
      </div>
    </div>
  );
};

export default ContestLayout;
